import { type ActionItem, DividerCustom } from 'shared/ui'
import { type Attachment } from 'entities/Attachment/model/Attachment'
import { type MediaLibraryStore } from 'widgets/MediaLibrary'
import { MediaLibraryVariant } from '../types/types'

export const getMediaLibraryCardActions = (
  attachment: Attachment,
  mediaLibraryStore: MediaLibraryStore
): ActionItem[] => {
  const {
    onOpenPresentationModal,
    onDeleteAttachments,
    onRenameAttachment,
    onAddToConversation,
    onDownloadAttachment,
    onCopyAttachment,
    mediaLibraryVariant,
  } = mediaLibraryStore
  const isAudio = attachment?.type === 'audio'
  const isVideo = attachment?.type === 'video'
  const isVCard = attachment?.type === 'vcard' || attachment?.extension === 'vcf'
  const isVCardPresentationAvailable = isVCard && !!attachment.vCard
  const isFile = attachment?.type === 'attachment' || isVCard
  const isAttachmentPresentationAvailable = !isFile || isVCardPresentationAvailable
  const isAudioSelectVariant = mediaLibraryVariant === MediaLibraryVariant.AudioSelect

  const previewLabel = () => {
    if (isVideo) return 'Play video'
    if (isAudio) return 'Play audio'
    return 'Preview'
  }

  const previewIcon = () => {
    if (isVideo || isAudio) return 'play'
    return 'expand2'
  }

  const actions = [
    {
      text: previewLabel(),
      icon: previewIcon(),
      buttonProps: {
        disabled: !isAttachmentPresentationAvailable,
        paddingInline: '8px 12px',
      },
      onAction: () => {
        onOpenPresentationModal(attachment)
      },
    },
    mediaLibraryVariant === MediaLibraryVariant.MessageField ||
    mediaLibraryVariant === MediaLibraryVariant.RinglessSelect
      ? {
          text: 'Add to conversation',
          icon: 'conversation',
          buttonProps: {
            paddingInline: '8px 12px',
          },
          onAction: () => {
            onAddToConversation([attachment])
          },
        }
      : null,
    {
      dropdownItemComponent: () => <DividerCustom variant={'dropdown'} />,
    },
    isAudioSelectVariant
      ? null
      : {
          text: 'Copy URL',
          icon: 'copy',
          buttonProps: {
            paddingInline: '8px 12px',
          },
          onAction: () => {
            onCopyAttachment(attachment)
          },
        },
    {
      text: 'Rename',
      icon: 'edit',
      buttonProps: {
        paddingInline: '8px 12px',
      },
      onAction: () => {
        onRenameAttachment(attachment)
      },
    },
    isAudioSelectVariant
      ? null
      : {
          text: 'Download',
          icon: 'download',
          buttonProps: {
            paddingInline: '8px 12px',
          },
          onAction: () => {
            void onDownloadAttachment(attachment)
          },
        },
    {
      text: 'Delete',
      icon: 'delete',
      buttonProps: {
        paddingInline: '8px 12px',
      },
      onAction: () => {
        void onDeleteAttachments([attachment.id])
      },
    },
  ]

  return actions.filter((item) => !!item) as ActionItem[]
}
